export default __webpack_public_path__ + "static/media/icon-love-poppy.b9447389.png";